import { FormControlLabel, Select, styled } from '@mui/material';
import { COLORS } from '../../../theme/color';

export const StyledInput = styled('input')<{
  icon?: any;
}>(({ icon }) => ({
  outline: 'none',
  border: '1px solid #D9D9D9',
  borderRadius: '15px',
  color: '#483D3D',
  width: '100%',
  padding: icon ? '1rem .5rem' : '1rem 1.5rem',
  fontSize: '16px',
  fontWeight: '400',
  letterSpacing: '1px',
  '&::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  },
  '&::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0
  },
  'input[type=number]': {
    '-moz-appearance': 'textfield'
  },
  '&:focus': {
    border: `1px solid ${COLORS.MainBlue} !important`
  },
  '&::placeholder': {
    color: '#A18D8E',
    fontSize: '14px',
    fontWeight: '300'
  }
}));

export const StyledImg = styled('img')({
  marginInlineStart: '1.5em'
});

export const ErrorType = styled('p')({
  color: `${COLORS.MainRed}!important`,
  fontSize: '1rem',
  fontWeight: '300'
});

export const Label = styled('label')({
  fontSize: '1.1rem',
  fontWeight: '400',
  marginBottom: '0.5rem'
});

export const SecLabel = styled('p')({
  fontSize: '1rem',
  fontWeight: '300',
  marginBottom: '1rem',
  color: COLORS.MildGray
});

export const ActionContainer = styled('div')({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  borderRadius: '6px'
});

export const Action = styled('div')({
  position: 'absolute',
  right: '1rem',
  top: '0',
  padding: '2px',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

export const StyledFormLabel = styled(FormControlLabel)(({ checked }) => ({
  '.MuiFormControlLabel-label': checked
    ? {
        fontWeight: 700
      }
    : {
        color: '#6F6F6F'
      },
  '.MuiSvgIcon-root': checked
    ? {
        color: COLORS.MainBlue
      }
    : {
        color: '#6F6F6F'
      }
}));

export const CustomSelect = styled(Select)({
  width: '100%',
  height: '56px',
  '& .MuiInputBase-input': {
    borderRadius: 4,
    backgroundColor: '#fff',
    // border: '1px solid #dbdce9',
    fontFamily: 'Outfit'
  }
});
